<template lang="pug">
  #MySa
    .container-width
      .p-4.text-center.mb-4
        h3.font-weight-bold.mb-3 美容顧問綁定成功!
        .smaller 我的美容顧問
        .ubs_pic_wrap.mt-3
          .ubs_pic
            img.w-100(:src='saInfo.sa.picture_url' alt='', style="border-radius: 50%")
          .ubs_pic_deco
            img(src='../../../assets/images/icon/profileBG_mask.png' alt='')

        h4.mb-2 {{ saInfo.sa.chinese_last_name }}{{ saInfo.sa.chinese_first_name }}
        p.mb-4
          i.fas.fa-map-marker-alt.mr-2
          span 櫃點：{{ saInfo.store.title }}
        .btn_wrap
          button.btn-custom.btn-b(
            type="button",
            @click.stop.prevent="sendMessage()"
            )
            span 開始與美容顧問一對一
</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import $ from 'jquery';

export default {
  name: 'BindSaSuccess',
  components: {
    ProfilePhotoSticker
  },
  data() {
    return {
      img: '' // 顯示圖片
    };
  },
  mounted() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
    if (!vm.saInfo) {
      vm.$swal.fire({
        icon: 'error',
        title: '非法嘗試[Err1]',
        showConfirmButton: false,
        showCancelButton: false,
        allowOutsideClick: false
      });
    }
    let str = navigator.userAgent.toLowerCase();
    let version = str.match(/cpu iphone os (.*?) like mac os/);
    let currentVersion = '0.0.0' ;
    if ( version && version[1]){
      currentVersion = version[1].replace(/_/g,'.');
    }
    let support = vm.isCurrentVersionSupport(currentVersion,'13.4.1');

    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    if (!isAndroid && !support) {
      $('#img').addClass('rotate90');
    }
  },
  methods: {
    sendMessage() {
      const vm = this;
      // 傳送開啟聊天室flex-message
          vm.$store.dispatch('member_my_sa/activateKeywordHandler')
            .then(() => {
              window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
            });
    },
    isCurrentVersionSupport(preVersion='', lastVersion='') {
      var sources = preVersion.split('.');
      var dests = lastVersion.split('.');
      var maxL = Math.max(sources.length, dests.length);
      var result = 0;
      for (let i = 0; i < maxL; i++) {
        let preValue = sources.length>i ? sources[i]:0;
        let preNum = isNaN(Number(preValue)) ? preValue.charCodeAt() : Number(preValue);
        let lastValue = dests.length>i ? dests[i]:0;
        let lastNum =  isNaN(Number(lastValue)) ? lastValue.charCodeAt() : Number(lastValue);
        if (preNum < lastNum) {
          result = false;
          break;
        } else if (preNum > lastNum) {
          result = true;
          break;
        }
      }
      return result;
    }
  },
  computed: {
    ...mapState({
      saInfo: (state) => state.member_bind_sa.saInfo
    })
  }
};
</script>

<style scoped>
  .ubs_pic_wrap {
    background-color: #000 !important;
    position: relative;
    max-width: 25rem;
    margin: 0 auto 1.5rem;
  }

  .ubs_pic {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 6rem;
    height: 6rem;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    border-radius: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  .ubs_pic_deco img {
    width: 101%;
    position: relative;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
  }

  .smaller {
    font-weight: 400;
  }

  .btn_wrap {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .btn-custom {
    background-color: $remind !important;
    color: #000 !important;
    border-radius: 9487px;
    font-size: 1.2rem;
    font-weight: 600;
    display: inline-block;
    text-align: center;
    -webkit-box-shadow: 0.1rem 0.1rem 0 rgba(0, 0, 0, 0.2);
    box-shadow: 0.1rem 0.1rem 0 rgba(0, 0, 0, 0.2);
    border: 0.2rem solid #000;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .btn-b {
    width: 100%;
    padding: 0.1rem 0;
  }
  .rotate90 {
    -webkit-transform: translate(-50%, -50%) rotate(90deg);
    transform: translate(-50%, -50%) rotate(90deg);
  }
</style>
